<script setup lang="ts">
import { onMounted, ref } from "vue";
import { tokenManager } from "../../../api/utils/tokenManager";
import { useRouter } from "vue-router";
import { Menu } from "../../../types/auth";
import IconComponent from "../../ui/common/IconComponent.vue";

const navigationMenu = ref<Menu[]>();

const router = useRouter()
onMounted(() => {
  let v: Menu[] = tokenManager.getMenu() || [];
  let cats = v.filter((o) => o["modules_id"] == null);

  cats.forEach((c) => {
    let cat_menu = v.filter((o) => o["modules_id"] == c.id);
    cat_menu.forEach((n) => {
      let mnu = v.filter((o) => o["modules_id"] == n.id);
      n.sub_menus = mnu;
    });
    c.sub_menus = cat_menu;
  });

  navigationMenu.value = cats;
});

const activeMenu = ref<string | null>(null);

const handleMouseEnter = (menu: string) => {
  activeMenu.value = menu;
};

const handleItemClick = (path: string) => {
  path = path.substring(0,1) == '/' ? path : '/' + path
  router.push(path)
}

const handleMouseLeave = () => {
  activeMenu.value = null;
};
</script>

<template>
  <div>
    <ul class="space-y-2">
      <li
        v-for="menu in navigationMenu"
        :key="menu.name"
        class="relative group"
        @mouseenter="handleMouseEnter(menu.name)"
        @mouseleave="handleMouseLeave"
      >
        <!-- Parent Menu -->
        <button
          class="flex items-center justify-between w-full px-2 py-2 text-left hover:bg-gray-700 rounded-md"
        >
          <IconComponent :name="menu.icon_css" />
        </button>

        <!-- Submenu appears on the right (2 columns) -->
        <div
          v-if="activeMenu === menu.name"
          class="absolute top-0 left-full w-80 bg-gray-800 shadow-lg border-l border-gray-700 p-4 w-[500px] z-[9999]"
        >
          <div class="grid grid-cols-2 gap-4">
            <div v-for="category in menu.sub_menus" :key="category.name">
              <h3 class="text-sm font-semibold text-gray-300 mb-2">
                {{ category.name }}
              </h3>
              <ul class="space-y-2">
                <li v-for="item in category.sub_menus" :key="item.name">
                  <a
                     href="#" 
                      @click.prevent="handleItemClick(item.route_path || '#')"
                    class="block text-xs text-gray-400 hover:text-white"
                  >
                  <div class="flex items-center gap-2">
                    <IconComponent :name="item.icon_css" /> 
                    <span>{{ item.name }}</span>
                  </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>
</div>
</template>

<style scoped>
nav {
  min-height: 100vh;
}
</style>
